import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useEotlCore = defineStore('eotlCore', {
    state: () => ({
        config: {
            mapboxToken: '',
            url_sextant: '',
            url_api: '',
            api_ending: ''
        },
        alert: {
            show: false,
            style: 'primary',
            title: 'Hello',
            message: 'This is just a default status message. Nothing to see here',
        },
        activeMapItemByAddress: null,
    }),
    actions: {
        init(data) {
            this.config.mapboxToken = data?.mapboxToken || ''
            this.config.url_sextant = data?.url_sextant || ''
            this.config.url_api = data?.url_api || ''
            this.config.api_ending = data?.api_ending || ''
        },

        // ALERT
        alertMsg(alert) {
            this.alert.message = alert?.message || ''
            this.alert.show = alert?.show || false
            this.alert.style = alert?.style || ''
            this.alert.title = alert?.title || ''
        },
        alertReset() {
            this.alert.message = ''
            this.alert.show = false
            this.alert.style = ''
            this.alert.title = ''
        },
        alertPrimary: function (message, title) {
            this.alertMsg({
                show: true,
                style: 'primary',
                title: title || 'Notification',
                message: message
            })
        },
        alertSuccess: function (message, title) {
            this.alertMsg({
                show: true,
                style: 'success',
                title: title || 'Success',
                message: message
            })
        },
        alertInfo: function (message, title) {
            this.alertMsg({
                show: true,
                style: 'info',
                title: title || 'Info',
                message: message
            })
        },
        alertWarning: function (message, title) {
            this.alertMsg({
                show: true,
                style: 'warning',
                title: title || 'Warning',
                message: message
            })
        },
        alertDanger: function (message, title) {
            this.alertMsg({
                show: true,
                style: 'danger',
                title: title || 'Error',
                message: message
            })
        },
        // API
        async fetchGet(endpoint, queryString = '') {
            let data = null
            let pending = true
            let errorMessage = null
            let status = 'pending'
            const api_request = this.config.url_api + endpoint + this.config.api_ending + queryString

            try {
                const response = await fetch(api_request, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                })

                if (!response.ok) {
                    const resError = await response.text()
                    const errorMessage = JSON.parse(resError)
                    this.alertDanger(errorMessage.detail)
                    throw new Error(errorMessage.detail)
                }

                const text = await response.text()
                data = JSON.parse(text)
                status = 'success'

            } catch (error) {
                this.alertWarning(error)
                errorMessage = error
                status = 'error'

                return {
                    status: status,
                    error: errorMessage,
                    pending,
                    data
                }

            } finally {
                pending = false
                status = 'success'
            }

            return {
                status: status,
                pending: pending,
                data,
                error: errorMessage
            }
        },
        async fetchPost(endpoint, record) {
            let data = null
            let pending = true
            let errorMessage = null
            let status ='pending'
            const api_request = this.config.url_api + endpoint + this.config.api_ending

            try {
                const response = await fetch(api_request, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(record),
                })

                if (!response.ok) {
                    const resError = await response.text()
                    const errorMessage = JSON.parse(resError)
                    this.alertDanger(errorMessage.detail)
                    throw new Error(errorMessage.detail)
                }

                const text = await response.text()
                data = JSON.parse(text)
                status = 'success'
            } catch (error) {
                this.alertWarning(error)
                errorMessage = error
                status = 'error'

                return {
                    status: status,
                    error: errorMessage,
                    pending,
                    data
                }
            } finally {
                pending = false
                status = 'success'
            }

            return {
                status: status,
                pending: pending,
                data,
                error: errorMessage
            }
        },
        async fetchPatch(endpoint, record) {
            let data = null
            let pending = true
            let errorMessage = null
            let status = 'pending'
            const api_request = this.config.url_api + endpoint + this.config.api_ending

            try {
                const response = await fetch(api_request, {
                    method: 'PATCH',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(record),
                })

                if (!response.ok) {
                    const resError = await response.text()
                    const errorMessage = JSON.parse(resError)
                    this.alertDanger(errorMessage.detail)
                    throw new Error(errorMessage.detail)
                }

                const text = await response.text()
                data = JSON.parse(text)
                status = 'success'
            } catch (error) {
                this.alertWarning(error)
                errorMessage = error
                status = 'error'

                return {
                    status: status,
                    error: errorMessage,
                    pending,
                    data
                }
            } finally {
                pending = false
                status = 'success'
            }

            return {
                status: status,
                pending: pending,
                data,
                error: errorMessage
            }
        },
        async fetchDelete(endpoint) {
            let data = null
            let pending = true
            let errorMessage = null
            let status = 'pending'
            const api_request = this.config.url_api + endpoint + this.config.api_ending

            try {
                const response = await fetch(api_request, {
                    method: 'DELETE',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                })

                if (!response.ok) {
                    const resError = await response.text()
                    const errorMessage = JSON.parse(resError)
                    this.alertDanger(errorMessage.detail)
                    throw new Error(errorMessage.detail)
                }

                const text = await response.text()
                data = JSON.parse(text)
                status = 'success'
            } catch (error) {
                this.alertWarning(error)
                errorMessage = error
                status = 'error'

                return {
                    status: status,
                    error: errorMessage,
                    pending,
                    data
                }
            } finally {
                pending = false
                status = 'success'
            }

            return {
                status: status,
                pending: pending,
                data,
                error: errorMessage
            }
        },
    },
})
